export default __webpack_public_path__ + "static/media/bar-tlm-services.73143729.svg";